const HC_API = {
    GENERATE_OTP: '/apps/holly-account/otp/generate',
    VALIDATE_OTP: '/apps/holly-account/otp/validate',
    UPDATE_CUSTOMER: '/apps/holly-account/customer/upsert',
    CHECK_CUSTOMER_STATE: '/apps/holly-account/Shopify/check-customer-status',
    SEND_MAIL_ACTIVATION: '/apps/holly-account/Shopify/send-mail-activation',
    SEND_RETURN_ITEMS: '/apps/hollyconnect/bff/refund',
    SEND_CANCEL_ITEMS: '/apps/hollyconnect/bff/cancel',
    SEND_GUEST_RETURN_ITEMS: '/apps/hollyconnect/bff/guest-refund',
    SEND_GUEST_CANCEL_ITEMS: '/apps/hollyconnect/bff/guest-cancel',
    MAKE_ANONYMOUS: "/apps/holly-account/Customer/make-anonymous",
    GET_GUEST_ORDER: '/apps/hollyconnect/bff/get-order',
    GET_INSTALLMENT: '/apps/holly-payments/payment/installment-plans',
    SET_ADDRESS_METAFIELD: '/apps/holly-account/Address/upsert-address',
    DELETE_ADDRESS_METAFIELD: '/apps/holly-account/Address',
    GET_PICKUP_AVAILABILITY: '/apps/hollyconnect/bff/get-warehouse-inventory'
}

const OTP_DATA = {
    DURATION_SEC: 180,
    LENGTH: 6,
    get ERROR_MESSAGE() { return window.otp?.locales?.ERROR_MESSAGE; },
    get EXPIRED_MESSAGE() { return window.otp?.locales?.EXPIRED_MESSAGE; },
    get WRONG_CODE_ERROR_MESSAGE() { return window.otp?.locales?.WRONG_CODE_ERROR_MESSAGE; },
    get ALREADY_USED_EMAIL_MESSAGE() { return window.otp?.locales?.ALREADY_USED_EMAIL_MESSAGE; }
}

const OTP_WRONG_CODE_MESSAGES = ['OTP has already been used', 'OTP not found'];
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const CUSTOMER_ENABLED_STATE = "ENABLED";
const CUSTOMER_NOT_FOUND_MESSAGE = "Customer not found";
